/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Confirm_New_PasswordInputs */

const en_common_confirm_new_password = /** @type {(inputs: Common_Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm New Password`)
};

const es_common_confirm_new_password = /** @type {(inputs: Common_Confirm_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar nueva contraseña`)
};

/**
* | output |
* | --- |
* | "Confirm New Password" |
*
* @param {Common_Confirm_New_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_confirm_new_password = /** @type {((inputs?: Common_Confirm_New_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Confirm_New_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_confirm_new_password(inputs)
	return en_common_confirm_new_password(inputs)
});